import { useEditorStore } from '../../store/editorStore';

const ANIMATION_PRESETS = [
  { value: 'none', label: 'None' },
  { value: 'fade-in', label: 'Fade In' },
  { value: 'fly-in-left', label: 'Fly In Left' },
  { value: 'fly-in-right', label: 'Fly In Right' },
  { value: 'fly-in-top', label: 'Fly In Top' },
  { value: 'fly-in-bottom', label: 'Fly In Bottom' },
  { value: 'zoom-in', label: 'Zoom In' },
  { value: 'rotate-in-left', label: 'Rotate In Left' },
  { value: 'rotate-in-right', label: 'Rotate In Right' },
  { value: 'drop', label: 'Drop' },
  { value: 'pulse', label: 'Pulse' },
  { value: 'spin', label: 'Spin' },
];

export default function AnimationProperties({ layer }) {
  const updateLayerAnimation = useEditorStore((s) => s.updateLayerAnimation);
  const anim = layer.animation;

  function update(field, value) {
    const current = anim || { preset: 'none', duration: 500, delay: 0, easing: 'ease' };
    updateLayerAnimation(layer.id, { ...current, [field]: value });
  }

  function setPreset(preset) {
    if (preset === 'none') {
      updateLayerAnimation(layer.id, undefined);
    } else {
      updateLayerAnimation(layer.id, {
        preset,
        duration: anim?.duration || 500,
        delay: anim?.delay || 0,
        easing: anim?.easing || 'ease',
      });
    }
  }

  const currentPreset = anim?.preset || 'none';

  return (
    <div className="p-2">
      <p className="panel-label mb-2">Animation</p>

      <div className="space-y-2">
        <div>
          <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Entrance Effect</label>
          <select
            value={currentPreset}
            onChange={(e) => setPreset(e.target.value)}
            className="input-field text-xs"
          >
            {ANIMATION_PRESETS.map((p) => (
              <option key={p.value} value={p.value}>{p.label}</option>
            ))}
          </select>
        </div>

        {currentPreset !== 'none' && anim && (
          <>
            <div className="grid grid-cols-2 gap-1.5">
              <div>
                <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Duration (ms)</label>
                <input
                  type="number"
                  value={anim.duration}
                  onChange={(e) => update('duration', parseInt(e.target.value) || 300)}
                  min={100}
                  max={5000}
                  step={100}
                  className="input-field py-1 text-xs"
                />
              </div>
              <div>
                <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Delay (ms)</label>
                <input
                  type="number"
                  value={anim.delay}
                  onChange={(e) => update('delay', parseInt(e.target.value) || 0)}
                  min={0}
                  max={5000}
                  step={100}
                  className="input-field py-1 text-xs"
                />
              </div>
            </div>

            <div>
              <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Easing</label>
              <select
                value={anim.easing}
                onChange={(e) => update('easing', e.target.value)}
                className="input-field text-xs"
              >
                <option value="ease">Ease</option>
                <option value="ease-in">Ease In</option>
                <option value="ease-out">Ease Out</option>
                <option value="ease-in-out">Ease In Out</option>
                <option value="linear">Linear</option>
              </select>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
